import api from './client.js'

export const kassaAPI = {
  getHealth:        () => api.get('/kassa/health'),
  getMenu:          () => api.get('/kassa/menu'),
  getLeaderboard:   () => api.get('/kassa/leaderboard'),
  getMyAccount:     () => api.get('/kassa/my-account'),
  placeOrder:       (items) => api.post('/kassa/order', { items }),
  rebuildMapping:   (dryRun = false) => api.post(`/kassa/admin/rebuild-mapping${dryRun ? '?dry=1' : ''}`),
  syncClan:         (dryRun = false) => api.post(`/kassa/admin/sync-clan${dryRun ? '?dry=1' : ''}`),
  fullSync:         (dryRun = false) => api.post(`/kassa/admin/full-sync${dryRun ? '?dry=1' : ''}`),
  getActiveEvent:   () => api.get('/kassa/active-event'),
  getSyncStatus:    () => api.get('/kassa/admin/sync-status'),
  getMyVouchers:    () => api.get('/kassa/my-vouchers'),
  pushUser:         (userId) => api.post(`/kassa/admin/users/${userId}/push`),
}
